'use client'

import { useEffect, useState } from 'react'
import styles from './page.module.css'

type MobileNavItem = Readonly<{
    label: string
    href?: string
}>

export function MobileNavigation({ items }: { readonly items: readonly MobileNavItem[] }) {
    const [isOpen, setIsOpen] = useState(false)

    useEffect(() => {
        if (!isOpen) {
            return
        }

        function handleKeyDown(event: KeyboardEvent) {
            if (event.key === 'Escape') {
                setIsOpen(false)
            }
        }

        const previousOverflow = document.body.style.overflow
        document.body.style.overflow = 'hidden'
        window.addEventListener('keydown', handleKeyDown)

        return () => {
            document.body.style.overflow = previousOverflow
            window.removeEventListener('keydown', handleKeyDown)
        }
    }, [isOpen])

    function closeMenu() {
        setIsOpen(false)
    }

    function openQuoteForm() {
        closeMenu()
        window.dispatchEvent(new Event('gmax:open-quote-form'))
    }

    return (
        <div className={styles.mobileNavigation}>
            <button
                aria-controls="mobile-navigation-menu"
                aria-expanded={isOpen}
                aria-label="Open main menu"
                className={styles.menuButton}
                type="button"
                onClick={() => setIsOpen(true)}
            >
                <span aria-hidden="true" />
            </button>

            {isOpen ? (
                <div className={styles.mobileMenuLayer} role="presentation" onClick={closeMenu}>
                    <aside
                        aria-label="Main navigation"
                        aria-modal="true"
                        className={styles.mobileMenuPanel}
                        id="mobile-navigation-menu"
                        role="dialog"
                        onClick={(event) => event.stopPropagation()}
                    >
                        <button
                            aria-label="Close main menu"
                            className={styles.mobileMenuClose}
                            type="button"
                            onClick={closeMenu}
                        >
                            Close
                        </button>
                        <nav className={styles.mobileMenuLinks} aria-label="Mobile navigation">
                            {items.map((item) =>
                                item.href === undefined ? (
                                    <span key={item.label} aria-disabled="true">
                                        {item.label}
                                    </span>
                                ) : (
                                    <a key={item.href} href={item.href} onClick={closeMenu}>
                                        {item.label}
                                    </a>
                                )
                            )}
                        </nav>
                        <div className={styles.mobileMenuActions}>
                            <a className={styles.primaryButton} href="#career" onClick={closeMenu}>
                                Join Our Fleet
                            </a>
                            <button
                                className={styles.secondaryButton}
                                type="button"
                                onClick={openQuoteForm}
                            >
                                Request a Quote
                            </button>
                        </div>
                        <address className={styles.mobileMenuContact}>
                            <strong>Call Us Now:</strong>
                            <a href="tel:+12249551251" onClick={closeMenu}>
                                (224) 955-1251
                            </a>
                            <a href="tel:+17738149417" onClick={closeMenu}>
                                (773) 814-9417
                            </a>
                        </address>
                    </aside>
                </div>
            ) : null}
        </div>
    )
}
